/**
 * Shared design tokens for AI surfaces (AI Coach drawer, inline hints,
 * check-in assessment, chat). Anywhere a component reaches for the AI brand
 * purple, it should import from here.
 */

export const PURPLE = '#6B35D4';
export const PURPLE_BG = '#EEE6FA';
export const PURPLE_BORDER_RGBA = 'rgba(107,53,212,0.15)';
export const PURPLE_GLOW_RGBA = 'rgba(107,53,212,0.2)';
